export enum VerticalAlignment {
	none = 'NONE',
	top = 'TOP',
	bottom = 'BOTTOM',
	center = 'CENTER'
}
